export default {
  general: {
    showHomeButton: true,
  },
};
